// dependencies
import { Map, Record } from "immutable";

const UserObject = {
	_id: "",
	name: "",
	hris_locked: false,
	dataFields: Map(),
	adminFields: Map(),
};

export default Record(UserObject);
